/**
 * Copyright (C) 2023 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */
import { Box, Stack } from '@mui/material';
import { EMPTY_FIELD_STRING_PLACEHOLDER } from '../../../utils/StringUtils';
import appTheme from '../../common/theme/appTheme.json';
import DataUsageChartContainer from './DataUsageChartContainer';
import { isNil } from 'lodash';

interface PerformanceSummaryChartProps {
  serviceAvailability: number | undefined | null;
  packetLoss: number | undefined | null;

  width: number;
}
const PerformanceSummaryChart = (props: PerformanceSummaryChartProps) => {
  const { serviceAvailability, packetLoss, width } = props;

  return (
    <DataUsageChartContainer width={width} header="Performance Summary">
      <Box
        sx={{
          backgroundColor: appTheme.primaryBackgroundColor,
          borderBottomLeftRadius: '8px',
          borderBottomRightRadius: '8px',
        }}
      >
        <Stack direction="row" sx={{ justifyContent: 'center', height: '383px' }}>
          <Stack spacing={3} sx={{ alignItems: 'center', justifyContent: 'center', height: '100%' }}>
            <Box
              sx={{
                fontFamily: appTheme.viasatFontFamilyRegular,
                color: appTheme.primaryTextColor,
                fontSize: '62px',
                fontWeight: '400',
                lineHeight: '20px',
                margin: '0px',
              }}
            >
              {!isNil(serviceAvailability) ? `${serviceAvailability}%` : EMPTY_FIELD_STRING_PLACEHOLDER}
            </Box>
            <Box
              sx={{
                fontFamily: appTheme.viasatFontFamilyRegular,
                color: appTheme.primaryTextColor,
                fontSize: '16px',
                fontWeight: '400',
                lineHeight: '32px',
                margin: '0px',
                printColorAdjust: '#000000',
              }}
            >
              Service Availability
            </Box>
          </Stack>
          <Stack
            spacing={3}
            sx={{ alignItems: 'center', justifyContent: 'center', height: '100%', marginLeft: '45px' }}
          >
            <Box
              sx={{
                fontFamily: appTheme.viasatFontFamilyRegular,
                color: appTheme.primaryTextColor,
                fontSize: '62px',
                fontWeight: '400',
                lineHeight: '20px',
                margin: '0px',
              }}
            >
              {!isNil(packetLoss) ? `${packetLoss}%` : EMPTY_FIELD_STRING_PLACEHOLDER}
            </Box>
            <Box
              sx={{
                fontFamily: appTheme.viasatFontFamilyRegular,
                color: appTheme.primaryTextColor,
                fontSize: '16px',
                fontWeight: '400',
                lineHeight: '32px',
                margin: '0px',
                printColorAdjust: '#000000',
              }}
            >
              Packet Loss
            </Box>
          </Stack>
        </Stack>
      </Box>
    </DataUsageChartContainer>
  );
};

export default PerformanceSummaryChart;
